import React from 'react';
import I18n from 'i18n-js';
import { RCToggledContent } from '@reverbdotcom/cadence/components';
import { Item2CspReviewsStarRating } from './item2_csp_reviews_star_rating';
import { Item2CspReviewsSection } from './item2_csp_reviews_section';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import {
  CoreItem2CspReviews,
} from '../schemas/rql';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';

const TRUNCATION_CONTAINER_REM_HEIGHT = 40;

interface IProps {
  heading?: string;
  csp: CoreItem2CspReviews.Csp;
  location?: any
  refetch?: () => void;
  pageOffset?: number;
}

const trackClick = (collapsed, componentName) => {
  trackEvent({
    eventName: MParticleEventName.ClickedToggledContent,
    componentName,
    interactionType: collapsed ? 'collapse' : 'expand',
  });
};

export default function Item2CSPReviews({ heading, csp, location, refetch, pageOffset }: IProps) {
  const inCspCtaSidebarExperiment = useExpEnabled(experiments.CSP_CTA_ON_ITEM_SIDEBAR);
  const setTruncationHeight = !location?.query?.review_page ? TRUNCATION_CONTAINER_REM_HEIGHT : null;
  if (!csp) { return null; }
  if (!csp?.reviews) { return null; }

  return (
    inCspCtaSidebarExperiment ?
      <Item2CspReviewsSection
        csp={csp}
        pageOffset={pageOffset}
        refetch={refetch}
        setTruncationHeight={setTruncationHeight}
        inCspCtaSidebarExperiment={inCspCtaSidebarExperiment}
      /> :
      <RCToggledContent
        heading={heading || I18n.t('discovery.item2Layout.reviews', { title: csp.title })}
        noResize
        additionalHeadingContent={<Item2CspReviewsStarRating csp={csp}/>}
        lockOpen={false}
        defaultOpen
        id="csp-reviews"
        onToggle={(collapsed) => trackClick(collapsed, 'Item2CSPReviews')}
      >
        <Item2CspReviewsSection
          csp={csp}
          pageOffset={pageOffset}
          refetch={refetch}
          setTruncationHeight={setTruncationHeight}
          inCspCtaSidebarExperiment={inCspCtaSidebarExperiment}
        />
      </RCToggledContent>
  );
}
